<well-payment-method-pending-view
  (checkStatus)="onCheckStatus()"
  (retryPayment)="onRetryPayment()"
  [paymentStatus]="currentPaymentStatus?.status ?? null"
>
</well-payment-method-pending-view>


